import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})

/**
 * Tabs component - handling the Tabs with navbar and content
 */
export class TabsComponent implements OnInit {

  // bread crumb items
  breadCrumbItems: Array<any>;

  // Collapse declare
  isCollapsed: boolean;

  constructor() { }

  ngOnInit() {
    // tslint:disable-next-line: max-line-length
    this.breadCrumbItems = [{ label: 'Aivis', path: '/' }, { label: 'UI Elements', path: '/' }, { label: 'Tabs & Accordions', path: '/', active: true }];

    // Collapse value
    this.isCollapsed = false;
  }

}
